import * as React from "react";
export default function Type() {
  return (
    <>Välj vilken typ av objekt du vill sätta upp rum och komponenter för.</>
  );
}
